import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88a4c69e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-hover-zoom" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "entry-preview-header p-2" }
const _hoisted_4 = { class: "pt-3" }
const _hoisted_5 = { class: "p-2 mt-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialSharing = _resolveComponent("SocialSharing")!
  const _component_attribute_list = _resolveComponent("attribute-list")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return ($props.thought)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["wdw-news-thought-preview mb-2 d-flex flex-column mx-auto", 'thought-' + $props.thought.id]),
        style: _normalizeStyle($setup.wrapperClass)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.readMore && $setup.readMore(...args)))
          }, [
            ($props.thought.files[0])
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "entry-preview-image",
                  src: $props.thought.files[0].url
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_SocialSharing, {
            url: $setup.thoughtURL,
            title: $props.thought.title,
            description: $props.thought.content
          }, null, 8, ["url", "title", "description"]),
          _createElementVNode("a", {
            class: "entry-preview-title",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.readMore && $setup.readMore(...args)))
          }, [
            _withDirectives(_createElementVNode("h5", _hoisted_4, null, 512), [
              [_directive_dompurify_html, $props.thought.title]
            ])
          ]),
          ($props.thought.attributes)
            ? (_openBlock(), _createBlock(_component_attribute_list, {
                key: 0,
                attributes: $props.thought.attributes
              }, null, 8, ["attributes"]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "entry-preview-content p-2",
          style: _normalizeStyle($setup.wrapperClass)
        }, null, 4), [
          [_directive_dompurify_html, $setup.getPlainText($props.thought.content)]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary d-flex m-auto",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.readMore && $setup.readMore(...args)))
          }, "weiterlesen")
        ])
      ], 6))
    : _createCommentVNode("", true)
}